import {createReducer, createActions} from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  usersRequest: ['props'],
  usersSuccess: ['data'],
  usersFailure: ['error'],
});

export const UsersTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  data: null,
  totalPages: 0,
  error: null,
  fetching: false,
});

/* ------------- Reducers ------------- */

// we're attempting to ...
export const request = state => state.merge({fetching: true});

// we've successfully ...
export const success = (state, {data}) =>
  state.merge({
    fetching: false,
    error: null,
    data: data ? data.page && data.page > 1 ? [...state.data, ...data.data] : data.data : null,
    totalPages: data && data.totalPages ? data.totalPages : 0,
  });

// we've had a problem ...
export const failure = (state, {error}) =>
  state.merge({fetching: false, error});


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.USERS_REQUEST]: request,
  [Types.USERS_SUCCESS]: success,
  [Types.USERS_FAILURE]: failure,
});
